"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _BrandSummary = _interopRequireDefault(require("./BrandSummary"));

require("../styles/_brands-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function BrandSummaryList(_ref) {
  var brands = _ref.brands,
      gotoBrand = _ref.gotoBrand,
      handleClick = _ref.handleClick,
      hasManagePermission = _ref.hasManagePermission;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
    className: "brands-list__label"
  }, _react.default.createElement(_uiKit.Icon, {
    classname: "icon-align",
    name: "brand",
    color: "russian",
    height: 25,
    width: 25,
    size: 25
  }), _react.default.createElement("p", null, "Our Brands"), hasManagePermission ? _react.default.createElement(_uiKit.Button, {
    type: "SECONDARY",
    small: true,
    onClick: handleClick
  }, "ADD BRANDING") : null), !(0, _lodash.default)(brands) ? _react.default.createElement("div", {
    className: "brands-list__images"
  }, brands && brands.map(function (_ref2) {
    var subBrandId = _ref2.subBrandId,
        coverImageKey = _ref2.coverImageKey,
        name = _ref2.name,
        updatedAt = _ref2.updatedAt;
    return _react.default.createElement(_BrandSummary.default, {
      gotoBrand: gotoBrand,
      subBrandId: subBrandId,
      key: subBrandId,
      coverImageKey: coverImageKey,
      name: name,
      updatedAt: updatedAt
    });
  })) : _react.default.createElement("div", {
    className: "brands-list__empty"
  }, _react.default.createElement("p", null, "Your Organisation has not added any brands yet")));
}

var _default = (0, _react.memo)(BrandSummaryList);

exports.default = _default;